/**
 * Wszystkie produkty WeSub mają zniżkę dla klubowiczów.
 * Ceny z API są już po obniżce, więc cenę bazową (tę przekreśloną)
 * wyliczamy wstecz.
 */
import { isTopOfferProduct } from "./wesub-product-flags";

export const CLUB_DISCOUNT_RATE = 0.15;

/** Produkty z „Top oferty" mają podwójnie wyższą cenę bazową, czyli 50% zniżki. */
export const TOP_OFFER_CLUB_DISCOUNT_RATE = 0.5;

export const CLUB_DISCOUNT_LABEL = `${Math.round(CLUB_DISCOUNT_RATE * 100)}%`;

export function clubDiscountRate(product: WesubProduct): number {
  return isTopOfferProduct(product)
    ? TOP_OFFER_CLUB_DISCOUNT_RATE
    : CLUB_DISCOUNT_RATE;
}

export function clubDiscountLabel(product: WesubProduct): string {
  return `${Math.round(clubDiscountRate(product) * 100)}%`;
}

export function priceBeforeClubDiscount(
  discountedPrice: number,
  rate: number = CLUB_DISCOUNT_RATE,
): number {
  return discountedPrice / (1 - rate);
}
